import type { SVGProps } from 'react';

const SvgDisplayHide = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M5.71 4.288a.996.996 0 1 0-1.41 1.41l1.51 1.51C3.96 8.728 3 10.668 3 11.998c0 2.47 3.42 7 9 7 1.58 0 3.11-.39 4.48-1.1l1.81 1.81c.2.2.45.29.71.29s.51-.1.71-.29a.996.996 0 0 0 0-1.41zM12 16.998c-4.36 0-7-3.47-7-5 0-.72.71-2.18 2.22-3.37l2.08 2.08a2.97 2.97 0 0 0 .58 3.41c.57.57 1.32.88 2.12.88.45 0 .89-.11 1.29-.3l1.7 1.7c-.93.39-1.93.6-2.99.6m0-12h-.37c-.55.02-.98.48-.96 1.04.02.55.49.99 1.04.96h.3c4.36 0 7 3.47 7 5 0 .16-.04.6-.42 1.3a.997.997 0 0 0 .88 1.48c.35 0 .7-.19.88-.52.44-.8.67-1.58.67-2.26 0-2.47-3.42-7-9-7z"
    />
  </svg>
);
export default SvgDisplayHide;
